<template>
  <!-- 工作台首页 -->
  <el-container
    class="workbench"
    style="display: block; overflow-y: scroll; height: calc(100vh - 50px)"
  >
    <div class="w-header">
      <div
        v-loading="loading.businessLoading"
        :style="{
          height: bussinessExpandFlag ? bussinessAutoHeight : '32px',
          transition: 'height .3s ease-in-out',
          overflow: 'hidden',
        }"
        class="wh-business"
      >
        <span>所属业务：</span>
        <div ref="bussinessGroup" class="whb-group">
          <div
            v-if="addButtonFlag.business"
            class="whbg-item whbg-add"
            @click="addNewBusi"
          >
            <i class="su-icon-plus" />
            <span>新增业务</span>
          </div>
          <div
            v-for="(item, index) in businessGroupData"
            :key="index"
            :title="item.process_role_name"
            :class="{
              'whbg-item': true,
              'whbg-item-active':
                item.process_role_name ===
                currentBusinessGroup.process_role_name,
              'whbg-item-last': index === businessGroupData.length - 1,
            }"
            @click="toggleBusinessGroup(item)"
          >
            <span
              style="
                max-width: 130px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >{{ item.process_role_name }}</span
            >
            <i class="su-icon-saf-success" @click="open_business_auth(item)" />
          </div>
        </div>
        <div
          v-show="bussinessMoreToggle"
          class="toggle-app-bussiness"
          style
          @click="bussinessExpandFlag = !bussinessExpandFlag"
        >
          <span v-show="!bussinessExpandFlag">更多</span>
          <span v-show="bussinessExpandFlag">收起</span>
          <i
            :class="{
              'su-icon-arrow': true,
              'su-icon-arrow-rotate': bussinessExpandFlag,
            }"
            style
          />
        </div>
      </div>
      <div v-loading="loading.appGroupLoading" class="wh-app">
        <span style="visibility: hidden">所属应组：</span>
        <div
          ref="appGroup"
          :style="{
            height: groupExpandFlag ? groupAutoHeight : '60px',
            transition: 'height .3s ease-in-out',
            marginLeft: '-10px',
          }"
          class="wha-group"
        >
          <div
            v-if="addButtonFlag.appGroup"
            class="whag-add"
            @click="addNewAppGroup"
          >
            <i class="su-icon-plus" />
            <span>新增应用组</span>
          </div>
          <div
            v-for="(item, index) in appGroupData"
            :key="'group' + index"
            :class="{
              'whag-item': true,
              'whag-item-active': item.id === currentAppGroup.id,
            }"
            @click.self="toggleAppGroup(item, index)"
          >
            <img
              :src="
                item.icon ||
                require('@/assets/default_images/default' +
                  ((index % 5) + 1) +
                  '.svg')
              "
              class="whagi-img"
              @click="toggleAppGroup(item, index)"
            />
            <div class="whagi-name" @click="toggleAppGroup(item, index)">
              {{ item.ff_group_name }}
            </div>
            <el-dropdown
              class="whagi-menu"
              trigger="click"
              @command="handleAGDropMenu"
            >
              <div>
                <img
                  :src="require('@/assets/images/formappgroupmoregray.png')"
                  class="whagim-icon-gray"
                />
                <img
                  :src="require('@/assets/images/formappgroupmore.png')"
                  class="whagim-icon"
                />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ type: 'warrant', item: item }">
                  <i class="su-icon-warrant" style="color: #3394e1" />授权
                </el-dropdown-item>
                <el-dropdown-item :command="{ type: 'dict', item: item }">
                  <i class="su-icon-dictionary" style="color: #3394e1" />字典
                </el-dropdown-item>
                <el-dropdown-item :command="{ type: 'interface', item: item }">
                  <i class="su-icon-annex" style="color: #3394e1" />接口
                </el-dropdown-item>
                <el-dropdown-item :command="{ type: 'detail', item: item }">
                  <i class="su-icon-details" style="color: #3394e1" />详情
                </el-dropdown-item>
                <el-dropdown-item :command="{ type: 'edit', item: item }">
                  <i class="su-icon-edit" style="color: #3394e1" />编辑
                </el-dropdown-item>
                <el-dropdown-item :command="{ type: 'delete', item: item }">
                  <i class="su-icon-delete" style="color: #3394e1" />删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <i
            v-for="(item, index) in 15"
            :key="item + index"
            class="whag-item-i"
          />
        </div>
        <div
          v-show="groupMoreToggle"
          class="toggle-app-group"
          style
          @click="groupExpandFlag = !groupExpandFlag"
        >
          <span v-show="!groupExpandFlag">更多</span>
          <span v-show="groupExpandFlag">收起</span>
          <i
            :class="{
              'su-icon-arrow': true,
              'su-icon-arrow-rotate': groupExpandFlag,
            }"
            style
          />
        </div>
      </div>
    </div>
    <div
      v-loading="loading.appLoading"
      v-if="currentAppGroup && currentAppGroup.ff_group_name"
      class="w-main"
    >
      <div class="wm-header">
        <div class="wmh-title">
          <img
            :src="
              currentAppGroup.icon ||
              require('@/assets/default_images/default' +
                ((currentAppGroup.index % 5) + 1) +
                '.svg')
            "
            class="wmht-icon"
          />
          <div class="wmht-text">{{ currentAppGroup.ff_group_name }}</div>
        </div>
        <div v-show="appData.length" class="wmh-search" style="width: 260px">
          <sw-input
            :placeholder="'输入应用名称进行筛选'"
            v-model="appSearchValue"
            clearable
          />
        </div>
      </div>
      <div class="wm-main">
        <div class="app-wrapper">
          <div v-if="addButtonFlag.app" class="add-app">
            <div class="aa-content">
              <div class="aac-item" @click="addNewApp">
                <i class="el-icon-plus" />
                <div class="aac-text">新增应用</div>
              </div>
              <el-divider />
              <div class="aac-item" @click="openImportAppDialog">
                <i class="el-icon-upload" />
                <div class="aac-text">导入应用</div>
              </div>
            </div>
          </div>
          <div
            v-for="(item, index) in filterAppData"
            :key="index"
            class="wmm-item"
          >
            <img
              :src="item.logo"
              style="width: 198px; height: 116px"
              @click="handleAppClick(item)"
            />
            <div class="wmmi-info" @click="handleAppClick(item)">
              <i
                :title="'移动分组'"
                class="ydfz su-icon-pm-CD"
                @click.stop="handleAppReplace(item)"
              />
              <i
                v-if="!item.deleteLoading"
                :title="'删除应用'"
                class="delete el-icon-delete"
                @click.stop="handleAppDelete(item)"
              />
              <i
                v-else
                :title="'删除中...'"
                class="delete el-icon-loading"
                @click.stop="handleAppDelete(item)"
              />
              <div :title="item.ff_name" class="wmmii-name ellipsis">
                {{ item.ff_name }}
              </div>
              <div class="wmmii-des">{{ item.ff_describe }}</div>
              <div class="wmmii-founder">
                <div class="wmmiif-key">创建人：</div>

                <div class="ellipsis wmmiif-text">{{ item.creatorName }}</div>
              </div>
            </div>
            <div class="wmmi-operation">
              <div class="wmmio-detail" @click="open_app_auth(item)">
                管理授权
              </div>
              <div class="wmmio-edit" @click="accessAuth(item)">访问授权</div>
            </div>
          </div>
          <i
            v-for="(item, index) in 15"
            :key="'ii' + index"
            class="wmm-item-i"
          />
        </div>
      </div>
    </div>
    <!-- 新增业务 -->
    <sw-slide-dialog :visible.sync="DBFlag" title="新增业务" width="30%">
      <span slot="footer">
        <sw-button size="small" @click="DBFlag = !DBFlag">取 消</sw-button>
        <sw-button
          :loading="DBBtnFlag"
          size="small"
          type="primary"
          @click="submitDialogBusiForm('busiForm')"
          >确 定</sw-button
        >
      </span>
      <el-form
        ref="busiForm"
        :model="busiForm"
        :rules="busiRules"
        :sw-validator="true"
        class="app-group-form"
        label-width="100px"
      >
        <el-form-item label="业务组名称" prop="name">
          <el-input v-model="busiForm.name" maxlength="50" />
        </el-form-item>
        <el-form-item label="业务组描述" prop="desc" style="margin-top: 50px">
          <el-input
            v-model="busiForm.desc"
            type="textarea"
            height="170px"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
      </el-form>
    </sw-slide-dialog>
    <!-- 新增/编辑应用组 -->
    <sw-slide-dialog :visible.sync="DAGFlag" :title="DAGTitle" width="30%">
      <span slot="footer">
        <sw-button size="small" @click="DAGFlag = !DAGFlag">取 消</sw-button>
        <sw-button
          :loading="DAGBtnFlag"
          size="small"
          type="primary"
          @click="submitDialogAppGroupForm('appGroupForm')"
          >确 定</sw-button
        >
      </span>
      <el-form
        ref="appGroupForm"
        :model="appGroupForm"
        :rules="agfRules"
        :sw-validator="true"
        class="app-group-form"
        label-width="100px"
      >
        <el-form-item label="应用组名称" prop="name">
          <el-input v-model="appGroupForm.name" maxlength="50" />
        </el-form-item>
        <el-form-item label="应用组描述" prop="desc" style="margin-top: 50px">
          <el-input
            v-model="appGroupForm.desc"
            type="textarea"
            height="170px"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
      </el-form>
    </sw-slide-dialog>
    <!-- 查看应用组详情 -->
    <sw-slide-dialog
      :visible.sync="appGroupDetailFlag"
      class="app-group-detail"
      title="应用组详情"
      width="30%"
    >
      <div
        v-if="currentAppGroup && currentAppGroup.ff_group_name"
        style="padding: 10px"
      >
        <div class="agd-header">
          <div class="agdh-left">
            <img
              :src="
                require('@/assets/default_images/default' +
                  ((currentAppGroup.index % 5) + 1) +
                  '.svg')
              "
              class="agdhl-icon"
            />
            <div class="agdhl-text">{{ appGroupDetailForm.name }}</div>
          </div>
        </div>
        <div class="agd-item">
          <div class="agdi-label">描述：</div>
          <div class="agdi-content">{{ appGroupDetailForm.desc }}</div>
        </div>
        <div class="agd-item">
          <div class="agdi-label">所属业务：</div>
          <div class="agdi-content">{{ appGroupDetailForm.business }}</div>
        </div>
        <div class="agd-userinfo">
          <div class="agd-item" style="margin-right: 90px">
            <div class="agdi-label">创建人：</div>
            <div class="agdi-content">{{ appGroupDetailForm.founder }}</div>
          </div>
          <div class="agd-item">
            <div class="agdi-label">创建时间：</div>
            <div class="agdi-content">{{ appGroupDetailForm.createdTime }}</div>
          </div>
        </div>
        <sw-table
          :show-selection="false"
          :has-operation="false"
          :table-name="'appGroupAuthTable'"
          :table-data="appGroupAuthData"
          :table-title="appGroupDetailFormTableTitle"
          :page-sizes="[10, 15, 20, 25]"
          :total-count="appGroupAuthCount"
          :page-size="appGroupAuthPageSize"
          :has-add-button="false"
          @size-change="changeAGATSize"
          @change-page="changeAGATPage"
          @next-page="changeAGATPage"
          @prev-page="changeAGATPage"
        />
      </div>
    </sw-slide-dialog>
    <!-- 新增应用 -->
    <sw-slide-dialog :visible.sync="DAFlag" :title="DATitle" width="30%">
      <span slot="footer">
        <sw-button size="small" @click="DAFlag = !DAFlag">取 消</sw-button>
        <sw-button
          :loading="DABtnFlag"
          size="small"
          type="primary"
          @click="submitDialogAppForm('appForm')"
          >确 定</sw-button
        >
      </span>
      <el-form
        ref="appForm"
        :model="appForm"
        :rules="afRules"
        :sw-validator="true"
        class="app-form"
        label-width="100px"
      >
        <el-form-item label="应用名称" prop="name">
          <el-input v-model="appForm.name" maxlength="50" />
        </el-form-item>
        <el-form-item label="应用描述" prop="desc" style="margin-top: 50px">
          <el-input
            v-model="appForm.desc"
            type="textarea"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="应用配图" style="margin-top: 50px" prop="imgSrc">
          <el-upload
            :on-change="changeFile"
            :http-request="successUploadAppImg"
            class="avatar-uploader"
            :action="imgAction"
            :show-file-list="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item label="应用部门" style="margin-top: 50px" prop="depId">
          <el-cascader
            v-model="appForm.depId"
            :options="appForm.depOptions"
            :show-all-levels="false"
            :props="{ value: 'id', label: 'ins_name', checkStrictly: true }"
            filterable
          />
        </el-form-item>
        <el-form-item label="游客模式" style="margin-top: 50px" prop="visitor">
          <el-switch
            v-model="appForm.visitor"
            active-value="1"
            inactive-value="0"
          />
        </el-form-item>
      </el-form>
    </sw-slide-dialog>
    <sw-dialog :visible.sync="importApp.flag" title="导入应用">
      <div style="text-align: center">
        <el-upload
          v-if="currentAppGroup && currentAppGroup.id"
          :action="baseUrl + '/v1/exportJson/loadJson'"
          :data="{ groupId: currentAppGroup.id }"
          :headers="{ authorization: authorization }"
          :show-file-list="false"
          :on-success="handleFileSuccess"
          :on-error="handleFileError"
          accept="application/json"
          drag
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">请上传应用json</div>
        </el-upload>
      </div>
    </sw-dialog>

    <sw-dialog :visible.sync="ydfz.visible" :width="'30%'" title="更换应用组">
      <el-form :label-position="'top'">
        <el-form-item label="更换应用组">
          <el-select
            v-model="ydfz.groupId"
            :remote-method="getAppgroupList"
            :loading="ydfz.loading"
            style="width: 100%"
            filterable
            remote
            reserve-keyword
            placeholder="输入关键字搜索"
          >
            <el-option
              v-for="item in ydfz.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="当前应用">
          <el-input :value="ydfz.curApp.ff_name" disabled />
        </el-form-item>
        <el-form-item label="当前应用组">
          <el-input
            :value="currentAppGroup ? currentAppGroup.ff_group_name : ''"
            disabled
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <sw-button @click="ydfz.visible = false">取 消</sw-button>
        <sw-button
          :loading="ydfz.loading"
          type="primary"
          @click="handleAppGroupUpdate"
          >确 定</sw-button
        >
      </span>
    </sw-dialog>
  </el-container>
</template>
<script>
import { encrypt } from '@/utils/crypto'
import { getCurDate } from '@/utils/index'
import service, { baseURL } from '@/utils/service'
import { parseTime } from '@/utils/index.js'
import './css/workbench.scss'
// import SwImgUpload from './components/sw-img-upload'
export default {
  // components: {
  //   SwImgUpload
  // },
  data () {
    return {
      appSearchValue: '',
      appGroupAuthItem: {},
      appGroupAuthPageSize: 10,
      appGroupAuthPage: 1,
      appGroupAuthCount: 0,
      appGroupAuthData: [],
      loading: {
        businessLoading: false,
        appGroupLoading: false,
        appLoading: false
      },
      addButtonFlag: {
        business: false,
        appGroup: false,
        app: false
      },
      groupAutoHeight: '60px',
      groupMoreToggle: true,
      bussinessMoreToggle: true,
      bussinessAutoHeight: '32px',
      DBFlag: false, // 新增业务
      DBBtnFlag: false,
      DAFlag: false, // 新增应用抽屉
      DABtnFlag: false, // 应用按钮loading
      DAGFlag: false, // 应用组查看/编辑抽屉
      DAGBtnFlag: false, // 应用组按钮loading
      appGroupDetailFlag: false, // 应用组详情抽屉
      groupExpandFlag: false, // 默认更多， true为收起
      bussinessExpandFlag: false,
      DAGTitle: '新增应用组',
      DATitle: '新增应用',
      currentBusinessGroup: null, // 当前业务
      businessGroupData: [], // 业务数据
      appData: [],
      currentAppGroup: null,
      appGroupData: [],
      appGroupDetailFormTableTitle: [
        { prop: 'auth_type', label: '授权类型', width: '120', sortable: false },
        {
          prop: 'auth_result',
          label: '授权结果',
          width: '120',
          sortable: true
        },
        { prop: 'auth_des', label: '授权说明', width: '120', sortable: true },
        { prop: 'auth_time', label: '授权时间', width: '120', sortable: true }
      ],
      appGroupDetailForm: {
        usage: true,
        name: '',
        desc: '',
        icon: require('@/assets/images/safePhone.svg'), // 图片路径
        business: '',
        founder: '',
        createdTime: '',
        auth: []
      },
      // 新增业务表单
      busiForm: {
        name: '',
        desc: ''
      },
      busiRules: {
        // 应用组弹出表单验证规则
        name: [
          { required: true, message: '请输入业务组名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '请填写1～50个字符',
            trigger: 'blur'
          }
        ],
        desc: [{ required: true, message: '请填业务组描述', trigger: 'blur' }]
      },
      appGroupForm: {
        // 应用组编辑表单
        id: '',
        name: '',
        desc: '',
        imgSrc: require('@/assets/images/safePhone.svg') // 图片路径
      },
      agfRules: {
        // 应用组弹出表单验证规则
        name: [
          { required: true, message: '请输入应用组名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '请填写1～50个字符',
            trigger: 'blur'
          }
        ],
        desc: [
          { required: true, message: '请填写应用组描述', trigger: 'blur' }
        ],
        imgSrc: [
          { required: true, message: '请选择应用组配图', trigger: 'blur' }
        ]
      },
      action: '/api/v1/file/service/file-upload/upload',
      imgAction: '',
      timeStr: '',
      fileList: [],
      imageUrl: '',
      appForm: {
        // 新增应用
        name: '',
        desc: '',
        imgSrc: '', // 图片路径
        visitor: '0',
        depId: '',
        depOptions: []
      },
      afRules: {
        // 应用弹出表单验证规则
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '请填写1～50个字符',
            trigger: 'blur'
          }
        ],
        desc: [{ required: true, message: '请填写应用描述', trigger: 'blur' }],
        imgSrc: [
          { required: true, message: '请选择应用配图', trigger: 'blur' }
        ]
      },
      workbenchCache: {
        roleid: '',
        groupid: ''
      },
      calcBusiHeightFlag: false,
      importApp: {
        flag: false
      },
      ydfz: {
        // 移动应用分组
        visible: false,
        options: [],
        groupId: '',
        loading: false,
        curApp: {}
      }
    }
  },
  computed: {
    baseUrl () {
      return baseURL
    },
    filterAppData () {
      const filterArr = this.appData.filter((item) => {
        return item.ff_name.indexOf(this.appSearchValue) > -1
      })
      return filterArr
    },
    authorization () {
      return 'Bearer ' + localStorage.getItem('Admin-Token')
    },
    fileBaseAPI () {
      return process.env.VUE_APP_FORM_FILE
    }
  },
  watch: {},
  created () {},
  mounted () {
    if (sessionStorage.getItem('workbenchCache')) {
      this.workbenchCache = JSON.parse(
        sessionStorage.getItem('workbenchCache')
      )
    }
    this.getBusinessGroup()
    this.getInstitution()
  },
  methods: {
    getAppgroupList (query) {
      if (!query) {
        this.ydfz.options = []
        return
      }
      this.ydfz.loading = true
      service({
        url: '/v1/act/queryFfgroupList',
        method: 'get',
        params: { groupName: query }
      }).then((res) => {
        this.ydfz.loading = false
        this.ydfz.options = res.data.map((item) => {
          return { label: item.groupName, value: item.groupId }
        })
      })
    },
    getInstitution () {
      service.get('/v1/institution/getInstitutionTreeData').then((res) => {
        this.appForm.depOptions = res
      })
    },
    // handleFileUploaderChange (file) {
    //   const is50kb = file.size <= 50 * 1024 // 限制小于50kb
    //   if (!is50kb) {
    //     this.$swMessage({
    //       message: `图片大小限制为50kb,该图片尺寸为${(file.size / 1024).toFixed(
    //         2
    //       )}kb`,
    //       type: 'error'
    //     })
    //     this.imageUrl = ''
    //     this.$set(this.appForm, 'imgSrc', this.imageUrl)
    //     return
    //   }
    //   const _this = this
    //   const reader = new FileReader()
    //   reader.readAsDataURL(file.raw)
    //   reader.onload = function (event) {
    //     const imgBase64 = this.result
    //     _this.imageUrl = imgBase64
    //     _this.$set(_this.appForm, 'imgSrc', _this.imageUrl)
    //   }
    // },

    successUploadAppImg () {
      if (this.fileList[0] && this.fileList[0].raw) {
        let file = this.fileList[0].raw
        console.log('file', file)
        this.uploadAction(file)
      }
    },
    uploadAction (file) {
      const xhr = new XMLHttpRequest()
      const url = this.imgAction
      xhr.open('POST', url, true)
      const token = localStorage.getItem('Admin-Token')
      xhr.setRequestHeader('X-Id-Token', token)
      const visitor = sessionStorage.getItem('visitor')
      xhr.setRequestHeader('visitor', visitor)
      xhr.setRequestHeader('timeStr', this.timeStr)
      const formData = new FormData()
      formData.append('file', file)
      xhr.send(formData)
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const resData = JSON.parse(xhr.response)
          if (
            resData &&
            resData.status === 200 &&
            resData.data &&
            resData.data.id
          ) {
            this.$set(this.fileList, 0, {
              ...this.fileList[0],
              id: resData.data.id,
              name: file.name,
              url:
                this.fileBaseAPI +
                '/api/v1/file/service/file-upload/view-img?id=' +
                resData.data.id,
              percentage: 100
            })
            setTimeout(() => {
              this.fileList[0] = { ...this.fileList[0], status: 'success' }
              this.imageUrl = this.fileList[0].url
              this.$set(this.appForm, 'imgSrc', this.imageUrl)
            }, 200)
          } else {
            this.$swMessage.error('图片上传失败,' + resData.message, true)
            this.fileList = []
            this.imageUrl = ''
            this.$set(this.appForm, 'imgSrc', this.imageUrl)
          }
        }
        console.log('this.fileList', this.fileList)
      }
    },
    changeFile (file, fileList) {
      const is50kb = file.size <= 50 * 1024 // 限制小于50kb
      if (!is50kb) {
        this.$swMessage({
          message: `图片大小限制为50kb,该图片尺寸为${(file.size / 1024).toFixed(
            2
          )}kb`,
          type: 'error'
        })

        if (
          !fileList[fileList.length - 1].url &&
          fileList[fileList.length - 1].status !== 'success'
        ) {
          fileList.splice(fileList.length - 1, 1)
        }
        this.fileList = fileList
        return
      }

      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.fileList = fileList
      console.log('this.fileList ', this.fileList)
    },
    beforeAvatarUpload (file) {
      const is1M = file.size / 512 / 512 < 512 // 限制小于1M
      if (!is1M) {
        this.$swMessage({
          message: `图片大小限制为50kb`,
          type: 'error'
        })
      }
      return is1M
    },
    handleAppClick (item) {
      this.$router.push({
        path: 'workbench/' + item.id,
        query: {
          form_id: item.form_id,
          yyid: item.yyid,
          roleid: this.currentBusinessGroup.id,
          groupid: this.currentAppGroup.id
        }
      })
    },
    handleAppDelete (item) {
      if (item.deleteLoading) {
        return
      }
      this.$swConfirm('确认放入回收站吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          item.deleteLoading = true

          return service.post('/v1/recycle/updateToRycycle', {
            yyid: item.yyid
          })
        })
        .then((res) => {
          this.appData = this.appData.filter((v) => {
            return v.yyid !== item.yyid
          })
          this.$swMessage.success(res.msg)
        })
        .catch((res) => {
          this.$swMessage.error(res.msg)
        })
        .finally(() => {
          item.deleteLoading = false
        })
    },
    handleAppReplace (item) {
      this.ydfz.curApp = item
      this.ydfz.visible = true
    },
    handleAppGroupUpdate () {
      this.ydfz.loading = true
      service
        .post('/v1/act/updateFfGroupByYyid', {
          yyid: this.ydfz.curApp.yyid,
          groupId: this.ydfz.groupId
        })
        .then((res) => {
          this.ydfz.visible = false
          this.$swMessage.success(res.msg)
        })
        .catch((res) => {
          this.$swMessage.error(res.msg)
        })
        .finally(() => {
          this.ydfz.loading = false
        })
    },
    open_dic_panel (appGroup) {
      this.$router.push({
        path: 'workbench/dictionary/' + appGroup.id,
        query: { name: appGroup.ff_group_name }
      })
    },
    open_interface_panel (appGroup) {
      this.$router.push('workbench/interface/' + appGroup.id)
    },
    open_edit_panel (appGroup) {
      this.DAGTitle = '编辑应用组'
      this.appGroupForm.id = appGroup.id
      this.appGroupForm.name = appGroup.ff_group_name
      this.appGroupForm.desc = appGroup.ff_group_describe
      this.DAGFlag = true
    },
    accessAuth (item) {
      this.$router.push({
        path: 'workbench/acl/' + item.id,
        query: { name: item.ff_name }
      })
    },
    editApp () {
      this.DATitle = '编辑应用组'
      this.DAFlag = true
    },
    calcBusiHeight () {
      this.$nextTick(() => {
        const node = this.$refs.bussinessGroup
        if (node.offsetHeight <= 32) {
          this.bussinessMoreToggle = false
        }
        this.bussinessAutoHeight = node.offsetHeight + 'px'
      })
    },
    getBusinessGroup () {
      this.loading.businessLoading = true
      service('/v1/authorization/showIndexPermission')
        .then((res) => {
          this.loading.businessLoading = false
          this.addButtonFlag.business = res.data.isAdmin
          if (!res.data.work.length) {
            return
          }

          const curBusi = res.data.work.filter((item) => {
            return item.id === this.workbenchCache.roleid
          })

          if (curBusi.length && !this.currentBusinessGroup) {
            this.toggleBusinessGroup(curBusi[0])
          } else {
            this.toggleBusinessGroup(res.data.work[0])
          }

          this.businessGroupData = res.data.work
          const _this = this
          setTimeout(function () {
            _this.calcBusiHeight() // 娃娃消失
          }, 1000)
        })
        .catch((err) => {
          this.$swMessage({
            message: `${err}`,
            type: 'error'
          })
        })
    },
    getAppGroup () {
      this.loading.appGroupLoading = true
      this.groupExpandFlag = false
      this.groupMoreToggle = true
      service('/v1/authorization/showAuthAppGroup', {
        params: {
          roleId: this.currentBusinessGroup.id
        }
      })
        .then((res) => {
          this.loading.appGroupLoading = false
          this.appGroupData = res.data.data
          this.addButtonFlag.appGroup = res.data.isAdmin
          if (!this.appGroupData.length) {
            this.groupMoreToggle = false
            this.currentAppGroup = {}
            this.appData = []
            return
          }
          this.$nextTick(() => {
            const nodes = document.querySelectorAll('.whag-item')
            if (!nodes.length) {
              return
            }
            if (nodes[nodes.length - 1].offsetTop < 60) {
              this.groupMoreToggle = false
            }

            this.groupAutoHeight =
              60 + nodes[nodes.length - 1].offsetTop + 'px'
          })

          const curGroup = this.appGroupData.filter((item, index) => {
            item.index = index
            return item.id === this.workbenchCache.groupid
          })
          if (curGroup.length && !this.currentAppGroup) {
            this.toggleAppGroup(curGroup[0], curGroup[0].index)
          } else {
            this.toggleAppGroup(this.appGroupData[0], 0)
          }
        })
        .catch((err) => {
          this.$swMessage({
            message: `${err}`,
            type: 'error'
          })
        })
    },
    getAppGroupDetail (item) {
      service('/v1/application/queryAppGroupInfo', {
        params: {
          id: item.id
        }
      })
        .then((res) => {
          this.appGroupDetailForm.name = res.data.ff_group_name
          this.appGroupDetailForm.desc = res.data.ff_group_describe
          this.appGroupDetailForm.founder = res.data.create_by
          this.appGroupDetailForm.business = res.data.process_role_name
          this.appGroupDetailForm.createdTime = parseTime(res.data.create_time)
          this.appGroupDetailFlag = true
        })
        .catch((err) => {
          this.$swMessage({
            message: `${err}`,
            type: 'error'
          })
        })
    },
    getAppGroupAuthList () {
      service
        .get('/v1/authorization/getAppGroupAuthList', {
          params: {
            ffGroupID: this.appGroupAuthItem.id,
            page: this.appGroupAuthPage,
            limit: this.appGroupAuthPageSize
          }
        })
        .then((res) => {
          this.appGroupAuthCount = res.count
          this.appGroupAuthData = res.data.map((item, index) => {
            let _item = null
            switch (item.authType) {
              case 'user':
                _item = {
                  id: index + '&' + item.id,
                  auth_type: '用户',
                  auth_des: item.description,
                  auth_result:
                    item.userName +
                    '-' +
                    item.realName +
                    '-' +
                    item.organizationName,
                  auth_time: parseTime(item.createTime)
                }
                break
              case 'userGroup':
                _item = {
                  id: index + '&' + item.id,
                  auth_type: '用户组',
                  auth_des: item.description,
                  auth_result: item.groupName,
                  auth_time: parseTime(item.createTime)
                }
                break
              default:
                _item = {
                  id: index + '&' + item.id,
                  auth_type: '用户组',
                  auth_des: item.description,
                  auth_result: item.groupName,
                  auth_time: parseTime(item.createTime)
                }
            }
            return _item
          })
        })
        .catch((error) => {
          this.$swMessage.error(error)
        })
    },
    changeAGATSize (pagesize) {
      this.appGroupAuthPageSize = pagesize
      this.appGroupAuthPage = 1
      this.getAppGroupAuthList()
    },
    changeAGATPage (page) {
      this.appGroupAuthPage = page
      this.getAppGroupAuthList()
    },
    getApp () {
      this.loading.appLoading = true
      service('/workCon/list', {
        params: {
          yyzid: this.currentAppGroup.id
        }
      })
        .then((res) => {
          this.loading.appLoading = false
          this.appData = res.data.data.map((item) => {
            item.deleteLoading = false
            return item
          })
          this.addButtonFlag.app = res.data.isAdmin
          if (!res.data.data.length) {
          }
        })
        .catch((err) => {
          this.$swMessage({
            message: `${err}`,
            type: 'error'
          })
        })
    },
    // 切换业务组
    toggleBusinessGroup (item) {
      this.currentBusinessGroup = item
      this.getAppGroup()
    },
    // 切换应用组
    toggleAppGroup (item, index) {
      this.currentAppGroup = item
      this.currentAppGroup['index'] = index
      this.getApp()

      const dir = getCurDate()
      this.timeStr = Date.now()
      const fileType = encrypt('', 'formflow' + this.timeStr)
      this.imgAction =
        this.fileBaseAPI +
        this.action +
        '?appId=' +
        this.currentAppGroup.id +
        '&dir=' +
        dir +
        '&fileType=' +
        encodeURIComponent(fileType)

      // console.log('this.imgAction', this.imgAction)
    },
    handleAGDropMenu (command) {
      switch (command.type) {
        case 'detail':
          this.getAppGroupDetail(command.item)
          this.appGroupAuthItem = command.item
          this.getAppGroupAuthList()
          break
        case 'edit':
          this.open_edit_panel(command.item)
          break
        case 'warrant':
          this.open_appgroup_auth(command.item)
          break
        case 'dict':
          this.open_dic_panel(command.item)
          break
        case 'interface':
          this.open_interface_panel(command.item)
          break
        case 'delete':
          this.deleteAppGroup(command.item)
          break
        default:
          console.error('错误：不匹配')
      }
    },
    open_app_auth (item) {
      this.$router.push({
        path: 'workbench/auth/' + item.id,
        query: { type: 'app', name: item.ff_name }
      })
    },
    open_appgroup_auth (item) {
      this.$router.push({
        path: 'workbench/auth/' + item.id,
        query: { type: 'appgroup', name: item.ff_group_name }
      })
    },
    open_business_auth (item) {
      this.$router.push({
        path: 'workbench/auth/' + item.id,
        query: { type: 'business', name: item.process_role_name }
      })
    },
    deleteAppGroup (item) {
      service
        .post('/v1/act/deleteManageGroup', {
          yyzid: item.id
        })
        .then((res) => {
          if (res.flag) {
            this.$swMessage({
              message: `应用组删除成功`,
              type: 'success'
            })
            this.getAppGroup()
          } else {
            this.$swMessage({
              message: res.msg,
              type: 'error'
            })
          }
        })
        .catch((res) => {
          this.$swMessage({
            message: res,
            type: 'error'
          })
        })
    },
    // 新增业务
    addNewBusi () {
      this.DBFlag = true
      this.busiForm.name = ''
      this.busiForm.desc = ''
    },
    // 新增应用组
    addNewAppGroup () {
      this.DATitle = '新增应用组'
      this.appGroupForm.name = ''
      this.appGroupForm.desc = ''
      this.DAGFlag = true
    },
    // 新增应用
    addNewApp () {
      this.DATitle = '新增应用'
      this.appForm.name = ''
      this.appForm.desc = ''
      this.appForm.imgSrc = ''
      this.imageUrl = ''
      this.DAFlag = true
    },
    openImportAppDialog () {
      this.importApp.flag = true
    },
    handleFileSuccess (res) {
      if (res.flag) {
        this.$swMessage({
          message: `导入成功`,
          type: 'success'
        })
        this.importApp.flag = false
      } else {
        this.$swMessage.error(res.msg)
      }
    },
    handleFileError (error) {
      this.$swMessage.error(error)
    },
    // 提交应用组表单
    submitDialogAppGroupForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAppGroupForm()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 提交应用表单
    submitDialogAppForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAppForm()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 添加业务组
    submitDialogBusiForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postBusiForm()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    postBusiForm () {
      this.DBBtnFlag = true
      service
        .post('/v1/authorization/createProcessRole', {
          processRoleName: this.busiForm.name,
          description: this.busiForm.desc
        })
        .then((res) => {
          this.getBusinessGroup()

          this.DBFlag = false
          this.$swMessage({
            message: `新增成功`,
            type: 'success'
          })
        })
        .catch((error) => {
          this.$swMessage.error(error)
        })
        .finally(() => {
          this.DBBtnFlag = false
        })
    },
    postAppGroupForm () {
      this.DAGBtnFlag = true
      if (this.DAGTitle === '新增应用组') {
        this.addNewAppGroupForm()
      } else {
        this.editAppGroupForm()
      }
    },
    addNewAppGroupForm () {
      service
        .post('/v1/application/createAppGroup', {
          belongRole: this.currentBusinessGroup.id,
          ff_group_name: this.appGroupForm.name,
          ff_group_describe: this.appGroupForm.desc
        })
        .then((res) => {
          this.getAppGroup()
          this.DAGFlag = false
          this.$swMessage({
            message: `新增成功`,
            type: 'success'
          })
        })
        .catch((error) => {
          this.$swMessage.error(error)
        })
        .finally(() => {
          this.DAGBtnFlag = false
        })
    },
    editAppGroupForm () {
      service
        .post('/v1/appAccess/updateGroupName ', {
          id: this.appGroupForm.id,
          ff_group_name: this.appGroupForm.name,
          ff_group_describe: this.appGroupForm.desc
        })
        .then((res) => {
          this.getAppGroup()
          this.DAGFlag = false
          this.$swMessage({
            message: `编辑成功`,
            type: 'success'
          })
        })
        .catch((error) => {
          this.$swMessage.error(error)
        })
        .finally(() => {
          this.DAGBtnFlag = false
        })
    },
    getImgBase64 (imgBase64) {
      this.appForm.imgSrc = imgBase64
    },

    // 嵌套格式转扁平格式
    dataToFlatten (data) {
      let arr = []
      data.forEach((item) => {
        arr.push({
          id: item.id,
          pid: item.pid,
          title: item.title
        })
        if (item.children && item.children.length) {
          arr = arr.concat(this.dataToFlatten(item.children))
        }
      })
      return arr
    },
    getDepName (depId) {
      const depOptions = this.dataToFlatten(this.appForm.depOptions)
      let dep = depOptions.filter((item) => {
        return item.id === depId[0]
      })
      dep = dep[0]
      return dep.title
    },
    postAppForm () {
      if (this.appForm.depId) {
        var deptName = this.getDepName(this.appForm.depId)
      }
      this.DABtnFlag = true
      service
        .post('/v1/application/createApp', {
          ff_groupId: this.currentAppGroup.id,
          appName: this.appForm.name,
          appDes: this.appForm.desc,
          logo: this.appForm.imgSrc,
          visitor: this.appForm.visitor,
          dept_id: this.appForm.depId,
          dept_name: deptName
        })
        .then((res) => {
          this.getApp()

          this.DAFlag = false
          this.$swMessage({
            message: `新增成功`,
            type: 'success'
          })
        })
        .catch((error) => {
          this.$swMessage.error(error)
        })
        .finally(() => {
          this.DABtnFlag = false
        })
    }
  }
}
</script>
